module.exports = __webpack_public_path__ + "img/pic3.abd79c1c.png";